import type { StudentWorksheet } from '@mathflat/domain/StudentWorksheet'
import type { SelfLearningWorksheet } from '@mathflat/domain/Worksheet'

export class SelfLearning {
  studentWorksheet: StudentWorksheet
  worksheet: SelfLearningWorksheet
  group: {
    studentWorksheet: StudentWorksheet
    worksheet: SelfLearningWorksheet
  }[]
  constructor({
    studentWorksheet,
    worksheet,
    group,
  }: {
    studentWorksheet: StudentWorksheet
    worksheet: SelfLearningWorksheet
    group: {
      studentWorksheet: StudentWorksheet
      worksheet: SelfLearningWorksheet
    }[]
  }) {
    this.studentWorksheet = studentWorksheet
    this.worksheet = worksheet
    this.group = group
  }
  get worksheetType() {
    return this.worksheet.selfLearningType
  }

  get status() {
    if (this.group.length > 1) {
      return this.group.every((item) => item.studentWorksheet.status === 'COMPLETE')
        ? 'COMPLETE'
        : this.group.every((item) => item.studentWorksheet.status === 'INCOMPLETE')
          ? 'INCOMPLETE'
          : 'PROGRESS'
    }

    return this.studentWorksheet.status
  }

  get wrongCount() {
    if (this.group.length > 1) {
      return this.group.reduce((result, curr) => {
        return curr.studentWorksheet.wrongCount ? result + curr.studentWorksheet.wrongCount : result
      }, 0)
    }
    return this.studentWorksheet.wrongCount
  }

  get correctCount() {
    if (this.group.length > 1) {
      return this.group.reduce((result, curr) => {
        return curr.studentWorksheet.correctCount
          ? result + curr.studentWorksheet.correctCount
          : result
      }, 0)
    }
    return this.studentWorksheet.correctCount
  }
}

export class SelfLearningColl {
  private _selfLearnings: SelfLearning[]

  constructor(selfLearnings: SelfLearning[]) {
    this._selfLearnings = selfLearnings
  }

  get hasLevelUp() {
    return this._selfLearnings.some((selfLearning) => selfLearning.worksheetType === 'LEVEL_UP')
  }
  get hasWrong() {
    return this._selfLearnings.some((selfLearning) => selfLearning.worksheetType === 'WRONG')
  }
  get disabledLevelUp() {
    return this._selfLearnings.some(
      (selfLearning) =>
        selfLearning.worksheetType === 'LEVEL_UP' &&
        (selfLearning.status !== 'COMPLETE' || selfLearning.wrongCount === 0),
    )
  }

  get disabledWrong() {
    return this._selfLearnings.some(
      (selfLearning) =>
        selfLearning.worksheetType === 'WRONG' &&
        (selfLearning.status !== 'COMPLETE' || selfLearning.wrongCount === 0),
    )
  }

  get completedLevelUp() {
    return (
      this._selfLearnings
        .filter((selfLearning) => selfLearning.worksheetType === 'LEVEL_UP')
        .every((selfLearning) => selfLearning.status === 'COMPLETE') &&
      this._selfLearnings
        .filter((selfLearning) => selfLearning.worksheetType === 'LEVEL_UP')
        .some((selfLearning) => selfLearning.wrongCount === 0)
    )
  }

  get completedWrong() {
    return (
      this._selfLearnings
        .filter((selfLearning) => selfLearning.worksheetType === 'WRONG')
        .every((selfLearning) => selfLearning.status === 'COMPLETE') &&
      this._selfLearnings
        .filter((selfLearning) => selfLearning.worksheetType === 'WRONG')
        .some((selfLearning) => selfLearning.wrongCount === 0)
    )
  }

  get size() {
    return this._selfLearnings.length
  }
  get toArr() {
    return this._selfLearnings
  }
}
